import React from "react";
import style from "./Title.module.scss";

const Title = ({children, className}) => (
    <h2 className={[style.title, className].join(" ")}>{children}</h2>
);

export default Title;
